import { TEAM_NAMES_DEFAULT } from '../constants.js';

// ── Shared mutable singleton for team-member names (C1 refactor extraction) ──
// Behavior-preserving move from App.jsx. This object is a SHARED MUTABLE ref:
//   • READ by NameCombo (src/components/NameCombo.jsx) — `.current.includes` / `.current.map`
//   • WRITTEN by App.jsx (the data loader sets `TEAM_NAMES_REF.current = names` once
//     team names arrive from the server).
// Both the writer (App.jsx) and the reader (NameCombo) import THIS module, so the
// ESM module-singleton guarantees they reference the SAME object — the mutation in
// App.jsx stays visible to NameCombo, exactly as when it lived inline in App.jsx.
export const TEAM_NAMES_REF = { current: [...TEAM_NAMES_DEFAULT] };
